export default {
  campaignTypes: (state) => {
    return state.campaignTypes;
  },
  campaignTypeCode: (state) => {
    return state.campaignTypeCode;
  },
  
  campaigns: (state) => {
    return state.campaigns;
  },
  campaign: (state) => {
    return state.campaign;
  },
  campaignCode: (state) => {
    return state.campaignCode;
  },

  leadTypes: (state) => {
    return state.leadTypes;
  },
  leadType: (state) => {
    return state.leadType;
  },
  leadTypeCode: (state) => {
    return state.leadTypeCode;
  },

  leadPropertys: (state) => {
    return state.leadPropertys;
  },
  leadProperty: (state) => {
    return state.leadProperty;
  },
  leadPropertyCode: (state) => {
    return state.leadPropertyCode;
  },

  leadSources: (state) => {
    return state.leadSources;
  },
  leadSource: (state) => {
    return state.leadSource;
  },
  leadSourceCode: (state) => {
    return state.leadSourceCode;
  },

  chancePrioritys: (state) => {
    return state.chancePrioritys;
  },
  chancePriority: (state) => {
    return state.chancePriority;
  },
  chancePriorityCode: (state) => {
    return state.chancePriorityCode;
  },

  failedSaleReasons: (state) => {
    return state.failedSaleReasons;
  },
  failedSaleReasonCode: (state) => {
    return state.failedSaleReasonCode;
  },

  strengthWeaknesses: (state) => {
    return state.strengthWeaknesses;
  },
  strengthWeakness: (state) => {
    return state.strengthWeakness;
  },
  strengthWeaknessCode: (state) => {
    return state.strengthWeaknessCode;
  },

  leadEvaluationQuestions: (state) => {
    return state.leadEvaluationQuestions;
  },
  leadEvaluationQuestion: (state) => {
    return state.leadEvaluationQuestion;
  },
  leadEvaluationQuestionCode: (state) => {
    return state.leadEvaluationQuestionCode;
  },

  saleRegions: (state) => {
    return state.saleRegions;
  },
  saleRegionCode: (state) => {
    return state.saleRegionCode;
  },

  saleTeams: (state) => {
    return state.saleTeams;
  },
  saleTeamCode: (state) => {
    return state.saleTeamCode;
  },

  leads: (state) => {
    return state.leads;
  },
  lead: (state) => {
    return state.lead;
  },
  leadId: (state) => {
    return state.leadId;
  },
  leadCode: (state) => {
    return state.leadCode;
  },
  leadStatistics: (state) => {
    return state.leadStatistics;
  },

  chances: (state) => {
    return state.chances;
  },
  chance: (state) => {
    return state.chance;
  },

  competitors: (state) => {
    return state.competitors;
  },
  competitor: (state) => {
    return state.competitor;
  },

  leadAddresses: (state) => {
    return state.leadAddresses;
  },
  leadAddress: (state) => {
    return state.leadAddress;
  },

  leadContactes: (state) => {
    return state.leadContactes;
  },
  leadContact: (state) => {
    return state.leadContact;
  },

  saleLines: (state) => {
    return state.saleLines;
  },
  saleLineCode: (state) => {
    return state.saleLineCode;
  },

  saleStageCode: (state) => {
    return state.saleStageCode;
  },
};
